<template>
  <!-- Model Start -->
  <div class="modal fade image-upload" :id="modalId" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitleImage" aria-hidden="true">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <!-- tabs start -->
          <ul class="nav nav-pills">
            <li class=" modal-tabs">
              <a href="#" class="active" data-toggle="pill" @click="activeTab = 'imageUpload'">
                {{ modalTitle }}
                <span class="fa fa-info-circle info-circle pl-5" aria-hidden="true" tabindex="-1" @click.prevent="toggleInfoDiv" @blur="hidePopup"></span>
                <div class="image-upload-info info-circle-div" v-show="instructionInfo">
                  <ul class="pl-25">
                    <li>Accepted formats: .png; .jpeg</li>
                    <li v-if="!removeMaxDimensions">
                      Max dimensions: 2048px x 2048px
                    </li>
                    <li>Min dimensions: 1080px x 1080px</li>
                    <li>
                      Large images will automatically resize to fit the width of the phone
                    </li>
                    <li>Image will automatically center</li>
                    <li>Image will be placed below step content</li>
                    <li>Only one image can be uploaded</li>
                  </ul>
                </div>
              </a>
            </li>
            <li v-if="hasMediaLibrary" class="modal-tabs">
              <a href="#" data-toggle="pill" @click="loadMediaLibrary">Media Library</a>
            </li>
          </ul>
          <!-- tabs End -->
          <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="close()">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body pl-31 pr-31 pt-26">
          <div class="tab-content text-center">
            <div id="imageUpload" class="tab-pane image-container" :class="{ active: activeTab === 'imageUpload' }">
              <div id="uploadImage" v-if="!imageProgress.show" @dragover.prevent @drop="onDropImage">
                <div class="image-content" v-if="!imageData.popupImageUrl">
                  <div class="upload-content">
                    <p>Drag and drop your image here.</p>
                    <button type="button" class="btn btn-outline-primary btn-sm" @click="uploadOrignalImage()">
                      Or upload an image
                    </button>
                    <input ref="fileinput" type="file" name="image" style="display:none;" accept="image/jpeg,image/png" @change="onImageUpload" />
                  </div>
                </div>
                <div class="hidden display-inline align-center" v-else v-bind:class="{ image: true }">
                  <img :src="imageData.popupImageUrl" alt="" class="img mt-40 mb-40" width="200" />
                  <a class="delete-image color_red cursor_pointer fs-15 mt-10 d-inline-block" v-if="imageData.popupImageUrl" @click="deleteImageUrl">
                    <i class="fa fa-trash fs-18" aria-hidden="true"></i>
                  </a>
                </div>
              </div>
              <div id="progressAreaImage" v-else>
                <div class="image-content">
                  <div class="progress-content">
                    <p>Uploading...</p>
                    <b-progress :value="imageProgress.percent" :max="imageProgress.max" class="mb-3 image-progress-bar"></b-progress>
                  </div>
                </div>
              </div>
            </div>
            <div class="tab-pane media-lib" :class="{ active: activeTab === 'mediaLibTab' }">
              <div class="row">
                <div class="fs-28 modal_header_color fw-200">
                  App Icon Library
                </div>
              </div>
              <p class="modal_desc">
                Don’t have a Icon? Don’t worry, we got you covered.
              </p>
              <div class="row pt-20">
                <template v-if="icons && icons.length > 0">
                  <div class="col-lg-3 col-md-3 col-sm-3 col-xs-3 pl-0 pr-0" v-for="(i, index) in icons" :key="index" @click="selectIcon(i)">
                    <div
                      class="library_img_bg"
                      :class="{
                        selected_icon_logo_image: i.name === selectedIcon.name
                      }"
                    >
                      <img class="img-responsive logo" :src="i.preSignedURL" />
                    </div>
                  </div>
                </template>
                <div v-if="(!icons || icons.length === 0) && !loadingMediaLib">
                  No icons present
                </div>
              </div>

              <div class="row text-center pt-20" v-if="totalPages > 1">
                <span v-if="currentPage !== 1" class="paginate" @click="getBrandingIcons(currentPage - 1)">
                  <i class="fa fa-chevron-left" aria-hidden="true"></i>
                </span>
                <span class="paginate" :class="{ active: currentPage === pageIndex + 1 }" :key="pageIndex" v-for="(page, pageIndex) in totalPages" @click="getBrandingIcons(pageIndex + 1)">
                  {{ pageIndex + 1 }}
                </span>
                <span v-if="currentPage !== totalPages" class="paginate" @click="getBrandingIcons(currentPage + 1)">
                  <i class="fa fa-chevron-right" aria-hidden="true"></i>
                </span>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer pr-31">
          <button type="button" class="btn btn-secondary mr-9" data-dismiss="modal" ref="imageCancel" @click="cancel()">
            Cancel
          </button>
          <button type="button" class="btn btn-primary" v-if="!imageData.popupImageUrl" disabled>
            Insert
          </button>
          <button type="button" class="btn btn-primary image" v-else @click="insertImage()">
            Insert
          </button>
        </div>
      </div>
    </div>
  </div>
  <!-- Model End -->
</template>

<script>
export default {
  name: "ImageUploadModel",

  props: {
    modalId: {
      type: String,
      default: "imageUploadSurvey"
    },
    modalTitle: {
      type: String,
      default: "Upload an Image"
    },
    hasMediaLibrary: {
      type: Boolean,
      default: true
    },
    questionSequence: {
      type: Number,
      default: 0
    },
    activityDetails: {
      type: Object,
      default: () => {}
    },
    removeMaxDimensions: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      activeTab: "imageUpload",
      instructionInfo: false,
      imageProgress: {
        show: false,
        percent: 0,
        max: 100
      },
      imageData: {
        popupImageUrl: "",
        popupImageId: ""
      },
      defaultData: {
        popupImageUrl: "",
        popupImageId: ""
      },
      fileInput: null,
      icons: [],
      selectedIcon: "",
      totalPages: 0,
      loadingMediaLib: false
    };
  },

  mounted() {
    this.fileInput = this.$refs.fileinput;
  },

  methods: {
    hidePopup(e) {
      this.instructionInfo = false;
      e.target.blur();
    },

    showPopup(e) {
      this.instructionInfo = true;
      e.target.focus();
    },

    toggleInfoDiv(e) {
      if (this.instructionInfo) {
        this.hidePopup(e);
      } else {
        this.showPopup(e);
      }
    },

    uploadOrignalImage() {
      this.fileInput.click();
    },

    imageProgressPercent() {
      setInterval(() => {
        if (this.imageProgress.percent >= this.imageProgress.max) {
          return;
        }
        this.imageProgress.percent++;
      }, 100);
    },

    loadMediaLibrary() {
      this.activeTab = "mediaLibTab";
      if (!this.icons.length) {
        this.getBrandingIcons(1);
      }
    },

    getBrandingIcons(pageNumber) {
      this.loadingMediaLib = true;
      this.currentPage = pageNumber;
      this.$api.getBrandingIconsFact(pageNumber).then(response => {
        this.icons = response.body.icons;
        this.totalPages = response.body.totalPages;
        this.loadingMediaLib = false;
      });
    },

    async onDropImage(e) {
      e.stopPropagation();
      e.preventDefault();
      const self = this;
      const files = e.dataTransfer.files;
      const selectedImage = files[0];
      if (files[0] && (await this.validateImage(files[0])) == false) {
        this.$toastr.error("Image upload failed. Please try again.");
        e.target.value = null;
        e.dataTransfer.files = null;
        return;
      }
      this.imageProgress.show = true;
      this.imageProgress.percent = 0;
      this.imageProgressPercent();
      const reader = new FileReader();
      reader.onload = e => {
        const file = {
          fileName: files[0].name,
          contentType: files[0].type,
          sequence: this.questionSequence,
          previousImageId: null,
          imageId: null,
          base64Code: e.target.result.split(",")[1]
        };
        this.$api
          .imageActivityUploadFact(this.activityDetails.id, file, false)
          .then(
            response => {
              if (response.data.result.imageUrl) {
                self.imageData.popupImageUrl = response.data.result.imageUrl;
                self.imageData.popupImageId = response.data.result.imageId;
              }
            },
            error => {
              self.errorMsg = error.body ? error.body.message : "Error while uploading the image.";
              this.$toastr.error(self.errorMsg);
              self.imageData.popupImageUrl = "";
              self.imageData.popupImageId = "";
            }
          )
          .finally(() => {
            self.fileInput.value = null;
            setTimeout(() => {
              this.imageProgress.show = false;
              this.imageProgress.percent = 0;
            }, 500);
          });
      };
      reader.readAsDataURL(selectedImage);
    },

    async onImageUpload(event) {
      const selectedImage = event.target.files[0];
      const validImage = await this.validateImage(selectedImage);

      if (!validImage) {
        this.$refs.fileinput.value = null;
        this.$toastr.error(`Image upload failed. Please try again.`);
        return;
      }

      this.imageProgress.show = true;
      this.imageProgress.percent = 0;
      this.imageProgressPercent();
      const self = this;
      const reader = new FileReader();
      reader.onload = e => {
        const file = {
          fileName: selectedImage.name,
          contentType: selectedImage.type,
          sequence: this.questionSequence,
          previousImageId: null,
          imageId: null,
          base64Code: e.target.result.split(",")[1]
        };
        this.$api
          .imageActivityUploadFact(this.activityDetails.id, file)
          .then(
            response => {
              this.imageProgress.percent = 100;
              if (response.data.result.imageUrl) {
                self.imageData.popupImageUrl = response.data.result.imageUrl;
                self.imageData.popupImageId = response.data.result.imageId;
              }
            },
            error => {
              self.errorMsg = error.body ? error.body.message : "Error while uploading the image.";
              this.$toastr.error(self.errorMsg);
              self.imageData.popupImageUrl = "";
              self.imageData.popupImageId = "";
            }
          )
          .finally(() => {
            self.fileInput.value = null;
            setTimeout(() => {
              this.imageProgress.show = false;
            }, 500);
          });
      };
      reader.readAsDataURL(selectedImage);
    },
    cancel() {
      this.imageData.popupImageUrl = "";
      this.imageData.popupImageId = "";
    },

    insertImage() {
      this.$emit("insertedImage", this.imageData);
      this.fileInput.value = null;
      this.imageData = Object.assign({}, this.defaultData);
      const elem = this.$refs.imageCancel;
      elem.click();
    },

    async validateImage(image) {
      const isValid = image.name.match(/.(png|jpg|jpeg)$/i);
      if (!isValid) {
        return false;
      }
      let hasValidDimention = false;

      // Validate Image dimention between 1024 - 2048
      try {
        hasValidDimention = await new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.readAsDataURL(image);
          reader.onload = event => {
            const img = new Image();
            img.onload = () => {
              if (this.removeMaxDimensions) {
                if (img.width >= 1080 && img.height >= 1080) {
                  resolve(true);
                }
                reject(false);
              } else {
                if (img.width >= 1024 && img.width <= 2048 && img.height >= 1024 && img.height <= 2048) {
                  resolve(true);
                }
                reject(false);
              }
            };
            img.src = event.target.result;
          };
        });
      } catch (error) {
        hasValidDimention = false;
      }

      return isValid && hasValidDimention;
    },

    selectIcon(page) {
      this.selectedIcon = {};
      this.selectedIcon = page;
      this.imageData.popupImageUrl = page.preSignedURL;
    },
    deleteImageUrl() {
      this.imageData.popupImageUrl = "";
      this.imageData.popupImageId = "";
      this.$toastr.success("Image deleted successfully");
    },
    close() {
      this.imageData.popupImageUrl = "";
      this.imageData.popupImageId = "";
    }
  }
};
</script>

<style lang="scss" scoped>
.image-upload {
  .modal-header {
    padding: 12px 31px;

    .close {
      margin: -1.2rem -2rem -0.8rem auto;
      color: #666669;
    }
  }

  .modal-tabs {
    a {
      color: #4a4a4a;
      font-size: 14px;
      padding: 0 5px 12px 0;
      margin-right: 30px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: normal;
      letter-spacing: normal;
      text-decoration: none;
      position: relative;

      .image-upload-info {
        height: auto;
        left: 60px;
        top: 25px;
        margin: 0;
        box-shadow: 0px 0px 2px #d3deef;

        ul {
          list-style: disc;
        }
      }
    }

    .active {
      border-bottom: 5px solid #4c8ce4;
    }
  }

  .image-container {
    width: 468px;
    min-height: 282px;
    background-color: #ffffff;
    background-color: #ffffff;
    background-image: url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' rx='4' ry='4' stroke='%23C5D1D6FF' stroke-width='3' stroke-dasharray='19%2c 10' stroke-dashoffset='29' stroke-linecap='square'/%3e%3c/svg%3e");
    border-radius: 4px;
  }

  .img-size {
    width: 100%;
    height: auto;
    float: none;
    max-width: 110px;
    max-height: 110px;
    padding: 5px;
  }

  .image-content {
    padding-top: 95px;
    padding-bottom: 165px;
    color: #4a4a4a;
    font-size: 14px;
    font-weight: normal;
  }

  .btn-primary {
    width: 124px;
    height: 38.7px;
    text-align: center;
    border-radius: 4px;
    border: solid 1px #4c8ce4;
    background-color: #4c8ce4;
    color: #ffffff;
  }

  .btn-secondary {
    width: 101px;
    height: 40px;
    text-align: center;
    border-radius: 4px;
    border: solid 1px #e4e8eb;
    background-color: #ffffff;
    color: #4a4a4a;
  }

  .btn-outline-primary {
    border: 2px solid #007bff;
  }
}

.media-lib {
  width: 468px;
  min-height: 330px;
}

.progress-modal {
  padding-top: 135px;
  padding-left: 170px;
  border-radius: 100%;
  display: none !important;
}

.progress-content {
  width: 300px;
  display: block !important;
  margin: auto !important;
}

.image-progress-bar {
  border-radius: 50px;
}
.delete-image {
  position: absolute;
  top: 54px;
  left: 370px;
}
</style>
